import React, { Fragment } from 'react';
import Head from 'next/head';
import { SITE_LOGO, X_SITE_LOGO } from 'constants/logos';
import { SITE_KEY, X_SITE } from 'constants/site';
import { AMP_HAMBURGER_LINKS_1, AMP_HAMBURGER_LINKS_2 } from 'constants/links';
import LogoLink from '../LogoLink';
import Close from '../Icons/Close';
import Hamburger from '../Icons/Hamburger';
import Search from '../Icons/Search';
import Link from '../Link';
import styles from './styles';

const renderLinkSection = (navigation, heading) => (
  <Fragment>
    <li key={heading} className="nav__heading">
      {heading}
    </li>
    {navigation.map(({ label, href, as, target, rel }) => (
      <li key={label} className="nav__item">
        <Link href={as || href}>
          <a className="nav__link" data-label={label} target={target} rel={rel}>
            {label}
          </a>
        </Link>
      </li>
    ))}
    <style jsx>{`
      .nav__heading {
        margin: 1.5rem 0 0.75rem;
        font-family: sans-serif;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0.05rem;
        text-transform: uppercase;
      }

      .nav__item {
        margin: 0.5rem 0;
      }

      .nav__link {
        color: #000;
        font-family: sans-serif;
        font-size: 14px;
        text-decoration: none;
      }
    `}</style>
  </Fragment>
);

function AmpHeader() {
  // TODO: set size/params on image URL!
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-sidebar"
          custom-element="amp-sidebar"
          src="https://cdn.ampproject.org/v0/amp-sidebar-0.1.js"
        />
      </Head>
      <header className="AmpHeader">
        <button
          className="AmpHeader__button AmpHeader__hamburger-open"
          on="tap:hamburger.open"
          aria-label="Open"
        >
          <Hamburger />
        </button>
        <div className={`AmpHeader__logo AmpHeader__logo--${SITE_KEY}`}>
          <LogoLink logo={SITE_LOGO} href="/" />
        </div>
        <Link href="/search">
          <a
            className="AmpHeader__button AmpHeader__search"
            aria-label="Search"
          >
            <Search />
          </a>
        </Link>
      </header>
      <amp-sidebar
        id="hamburger"
        layout="nodisplay"
        side="left"
        className="HamburgerNav"
      >
        <button
          className="AmpHeader__button AmpHeader__hamburger-close"
          on="tap:hamburger.close"
          aria-label="Close"
        >
          <Close />
        </button>
        <nav toolbar="(min-width: 0px)" toolbar-target="amp-footer-nav">
          <ul>
            {renderLinkSection(AMP_HAMBURGER_LINKS_1, 'Read')}
            {renderLinkSection(AMP_HAMBURGER_LINKS_2, 'Company')}
          </ul>
        </nav>
        <div className="AmpHeader__xsite-link">
          Visit our partner site
          <LogoLink logo={X_SITE_LOGO} href={X_SITE} />
        </div>
      </amp-sidebar>
      <style jsx>{styles}</style>
    </Fragment>
  );
}

export default AmpHeader;
